<script setup lang="ts">
import OfferingsTable from '@/components/OfferingsTable.vue'

definePage({ meta: { requiresAuth: true } })

const route = useRoute('dive-centers-id-offerings-rentals')
const id = String(route.params.id)
</script>

<template>
  <!-- El valor interno del tipo sigue siendo 'product'; en la UI es "Rental"
       desde §14. Cambiarlo ahora sería tocar el modelo por una etiqueta. -->
  <OfferingsTable
    :dc-id="id"
    kind="product"
  />
</template>
